import Image from "next/image";
import { Popover } from "@headlessui/react";
import style from "./home_property.module.css";
import CustomerContext from "@/stores/customer-context";
import { Fragment, useContext, useEffect, useState } from "react";
import InputSelect from "../UI/input-select/input_select";
import { homePropertyAssets } from "@/helpers/constant/content_data";

export function HomeProperty({ values, onBlur, errors, touched, onChange, setFieldValue }) {
  const customerCtx = useContext(CustomerContext);
  const [selectedFurnitureValue, setSelectedFurnitureValue] = useState(null);
  const [selectedApplicantValue, setSelectedApplicantValue] = useState(null);
  const [propertyAssetsList, setPropertyAssetsList] = useState(homePropertyAssets);
  const [propertyRangeValues, setPropertyRangeValues] = useState([]);
  const [propertyRangeOptions, setPropertyRangeOptions] = useState([]);

  useEffect(() => {
    const _propertyRangeValues = [];
    const _propertyRangeOptions = [];
    propertyAssetsList.forEach((range) => {
      _propertyRangeValues.push(range.value);
      _propertyRangeOptions.push(range.option);
    });
    setPropertyRangeValues(_propertyRangeValues);
    setPropertyRangeOptions(_propertyRangeOptions);
  }, [propertyAssetsList]);

  useEffect(() => {
    const asset = parseInt(values["homeFurniture"]) + parseInt(values["homeApplicant"]);
    setFieldValue("homeAsset", asset);
  }, [values]);

  return (
    <Fragment>
      <div className={style.home_property_assets_info_wrapper}>
        <Popover className={style.home_property_assets_info}>
          <Popover.Button>
            <Image src="/assets/icon-svg/icon-tooltip-btn.svg" width={16} height={16} priority={true} />
          </Popover.Button>
          <Popover.Panel className={style.home_property_assets_popover}>
            <p>ราคาทรัพย์สินประมาณ การภายในตัวอาคาร</p>
          </Popover.Panel>
        </Popover>
      </div>
      <div className={style.home_property_assets_remark}>
        <p>
          ทรัพย์สิน ไม่รวมถึง ทรัพย์สินที่<u>ไม่ได้คุ้มครอง</u>ตามเงื่อนไขกรมธรรม์ เช่น เงิน ทอง กล้อง มือถือ
          นาฬิกา ต้นไม้ โบราณวัตถุ ศิลปวัตถุ อัญมณี บัตรเครดิต คอมพิวเตอร์พกพา เสาโทรทัศน์ จานดาวเทียม เป็นต้น
        </p>
      </div>
      <div className={style.input_group}>
        <InputSelect
          name="homeFurniture"
          onChange={onChange}
          onBlur={onBlur}
          placeholder={"เลือกมูลค่า"}
          title={"เฟอร์นิเจอร์ลอยตัวและบิวท์อินภายในบ้าน"}
          initValue={values.homeFurniture == 0 ? propertyRangeValues[0] : values.homeFurniture}
          options={propertyRangeOptions}
          values={propertyRangeValues}
          theme="black"
          hasUnChangeState={true}
          withRequredMark={true}
          errorMsg={errors.homeFurniture && touched.homeFurniture ? errors.homeFurniture : ""}
        />
      </div>
      <div className={style.input_group}>
        <InputSelect
          name="homeApplicant"
          onChange={onChange}
          onBlur={onBlur}
          title={"เครื่องใช้ไฟฟ้า เครื่องครัว และทรัพย์สิน"}
          placeholder={"เลือกมูลค่า"}
          initValue={values.homeApplicant == 0 ? propertyRangeValues[0] : values.homeApplicant}
          options={propertyRangeOptions}
          values={propertyRangeValues}
          theme="black"
          hasUnChangeState={true}
          withRequredMark={true}
          errorMsg={errors.homeApplicant && touched.homeApplicant ? errors.homeApplicant : ""}
        />
      </div>
    </Fragment>
  );
}
